import { Listbox, Menu, Switch } from "@headlessui/react";
import React from "react";
import { BiLoaderCircle } from "react-icons/bi";
import DatePicker from "react-datepicker";
import { FaCheck } from "react-icons/fa";
import { useMediaQuery } from "@mui/material";

export function Input({
  label,
  name,
  type,
  color,
  placeholder,
  register,
  onChange,
  value,
  min,
  disabled,
  autocomplete,
}) {
  return (
    <div className="text-sm w-full">
      <label
        className={`${
          color ? "text-black text-sm" : "text-white font-semibold"
        } `}>
        {label}
      </label>
      <input
        disabled={disabled}
        name={name}
        onChange={onChange}
        {...register}
        value={value}
        type={type}
        min={min}
        placeholder={placeholder}
        autoComplete={autocomplete}
        className={`w-full bg-transparent text-sm mt-3 p-4 border ${
          color ? "border-border font-light" : "border-white text-white"
        } rounded-lg focus:border focus:border-subMain`}
      />
    </div>
  );
}

// button

export function Button({
  label,
  onClick,
  loading,
  Icon,
  bgColor = "subMain",
  className,
  disabled,
}) {
  return (
    <button
      disabled={loading || disabled}
      onClick={onClick}
      className={`w-full flex-rows gap-4 transitions px-2 py-4 rounded-lg text-md font-medium ${
        loading || disabled
          ? "bg-gray-400 cursor-not-allowed text-gray-200"
          : `bg-${bgColor} hover:opacity-80 text-white`
      } ${className}`}>
      {loading ? (
        <BiLoaderCircle className="animate-spin text-white text-2xl" />
      ) : (
        <>
          {Icon && <Icon className="text-white text-xl" />}
          {label}
        </>
      )}
    </button>
  );
}

export function ButtonServices({
  label,
  onClick,
  loading,
  Icon,
  bgColor = "subMain",
  className,
}) {
  return (
    <button
      disabled={loading}
      onClick={onClick}
      className={`w-full flex-rows gap-4 hover:opacity-80 transitions bg-${bgColor} text-white text-sm font-medium px-2 py-4 rounded-lg ${className}`}>
      {loading ? (
        <BiLoaderCircle className="animate-spin text-white text-2xl" />
      ) : (
        <>
          {Icon && <Icon className="text-white text-xl" />}
          {label}
        </>
      )}
    </button>
  );
}
export function ButtonOmar({
  label,
  onClick,
  loading = false,
  Icon = null,
  variant = "solid",
  bgColor = "bg-subMain", // Use Tailwind color classes directly
  textColor = "text-white",
  hoverColor = "hover:bg-subMain-600",
  size = "md",
  rounded = "lg",
  iconPosition = "left",
  className = "",
  disabled = false,
}) {
  const sizeClasses = {
    sm: "px-3 py-1 text-sm",
    md: "px-4 py-2 text-md",
    lg: "px-6 py-3 text-lg",
  };

  const roundedClasses = {
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    full: "rounded-full",
  };

  return (
    <button
      disabled={loading || disabled}
      onClick={onClick}
      className={`flex items-center justify-center gap-2 transition-all duration-200 ${bgColor} ${textColor} 
        ${hoverColor} ${sizeClasses[size]} ${roundedClasses[rounded]} 
        disabled:opacity-50 disabled:cursor-not-allowed ${className}`}>
      {loading ? (
        <BiLoaderCircle className="animate-spin text-xl" />
      ) : (
        <>
          {iconPosition === "left" && Icon && <Icon className="text-xl" />}
          <span>{label}</span>
          {iconPosition === "right" && Icon && <Icon className="text-xl" />}
        </>
      )}
    </button>
  );
}

// select

export function MenuSelect({ children, datas, item: data }) {
  const isMobile = useMediaQuery("(max-width:800px)");
  return (
    <div className="text-sm w-full flex-grow relative">
      <Menu>
        <Menu.Button>{children}</Menu.Button>
        <Menu.Items className="flex flex-col z-50 gap-4 absolute left-0 w-full bg-white rounded-md shadow-lg py-4 px-6 ring-1 ring-border focus:outline-none">
          {datas.map((item, index) => (
            <button
              onClick={() => item.onClick(data)}
              key={index}
              className={`flex gap-${
                isMobile ? "0.2" : "4"
              } items-center hover:text-subMain ${
                isMobile && "justify-center"
              }`}>
              {item.icon && <item.icon className={`text-md text-subMain`} />}
              {item.title}
            </button>
          ))}
        </Menu.Items>
      </Menu>
    </div>
  );
}

export function ButtonJuli({
  label,
  onClick,
  loading = false,
  Icon = null,
  variant = "solid",
  bgColor = "bg-subMain", // Use Tailwind color classes directly
  textColor = "text-white",
  hoverColor = "hover:bg-subMain-600",
  size = "md",
  rounded = "lg",
  iconPosition = "left",
  className = "",
  disabled = false,
}) {
  const sizeClasses = {
    sm: "px-3 py-1 text-sm",
    md: "px-4 py-2 text-md",
    lg: "px-6 py-3 text-lg",
  };
  const roundedClasses = {
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    full: "rounded-full",
  };
  return (
    <button
      disabled={loading || disabled}
      onClick={onClick}
      className={`flex items-center justify-center gap-2 transition-all duration-200 ${bgColor} ${textColor} 
        ${hoverColor} ${sizeClasses[size]} ${roundedClasses[rounded]} 
        disabled:opacity-50 disabled:cursor-not-allowed ${className}`}>
      {loading ? (
        <BiLoaderCircle className="animate-spin text-xl" />
      ) : (
        <>
          {iconPosition === "left" && Icon && <Icon className="text-xl" />}
          <span>{label}</span>
          {iconPosition === "right" && Icon && <Icon className="text-xl" />}
        </>
      )}
    </button>
  );
}

// select 2

export function Select({
  children,
  selectedPerson,
  setSelectedPerson,
  datas,
  onChange,
  disabled = false, // Accept disabled as a prop
}) {
  return (
    <div
      className={`text-sm relative w-full ${
        disabled ? "opacity-60 pointer-events-none" : ""
      }`}>
      <div className="w-full">
        <Listbox
          value={selectedPerson}
          onChange={(value) => {
            if (!disabled) {
              setSelectedPerson(value);
              if (onChange) onChange(value); // Ensure changes propagate
            }
          }} // Prevent changing value if disabled
          disabled={disabled} // Headless UI Listbox supports this prop
        >
          <Listbox.Button
            className={`w-full ${disabled ? "cursor-not-allowed" : ""}`} // Visual indicator
          >
            {children}
          </Listbox.Button>
          {!disabled && (
            <Listbox.Options className="flex flex-col gap-4 top-10 z-50 absolute left-0 w-full bg-white rounded-md shadow-lg py-4 px-6 ring-1 ring-border focus:outline-none">
              {datas.map((person, index) => (
                <Listbox.Option
                  className={`cursor-pointer text-xs hover:text-subMain`}
                  key={person.id || index}
                  value={person}
                  disabled={person.unavailable}>
                  {person.name}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          )}
        </Listbox>
      </div>
    </div>
  );
}

export function SelectHorizontal({
  children,
  selectedPerson,
  setSelectedPerson,
  datas,
  onChange,
  disabled = false, // Accept disabled as a prop
}) {
  return (
    <div
      className={`text-sm relative w-full ${
        disabled ? "opacity-60 pointer-events-none" : ""
      }`}>
      <div className="w-full">
        <Listbox
          value={selectedPerson}
          onChange={(value) => !disabled && setSelectedPerson(value)} // Prevent changing value if disabled
          disabled={disabled} // Headless UI Listbox supports this prop
        >
          <Listbox.Button
            className={`w-full ${disabled ? "cursor-not-allowed" : ""}`} // Visual indicator
          >
            {children}
          </Listbox.Button>
          {!disabled && (
            <Listbox.Options className="flex flex-row gap-4 z-50 absolute left-0 top-full w-full bg-white rounded-md shadow-lg py-4 px-6 ring-1 ring-border focus:outline-none overflow-auto max-w-full">
              {datas.map((person, index) => (
                <Listbox.Option
                  className="cursor-pointer text-xs hover:text-subMain p-2 border rounded-md hover:bg-gray-100"
                  key={person.id || index}
                  value={person}
                  disabled={person.unavailable}>
                  {person.name}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          )}
        </Listbox>
      </div>
    </div>
  );
}

export function SelectStaff({
  children,
  selectedPerson,
  setSelectedPerson,
  datas,
  onChange,
}) {
  return (
    <div className="text-sm relative w-full">
      <div className="w-full">
        <Listbox value={selectedPerson} onChange={onChange}>
          <Listbox.Button className={"w-full"}>{children}</Listbox.Button>
          <Listbox.Options className="flex flex-col gap-4 top-10 z-50 absolute left-0 w-full bg-white rounded-md shadow-lg py-4 px-6 ring-1 ring-border focus:outline-none">
            {datas.map((person, index) => (
              <Listbox.Option
                className={`cursor-pointer text-xs hover:text-subMain`}
                key={person.id || index}
                value={person}
                disabled={person.unavailable}>
                {person.name}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Listbox>
      </div>
    </div>
  );
}

export function SelectServices({
  children,
  selectedPerson,
  setSelectedPerson,
  datas,
  onChange,
}) {
  return (
    <div className="text-sm relative w-full">
      <div className="w-full">
        <Listbox value={selectedPerson} onChange={onChange}>
          <Listbox.Button className={"w-full"}>{children}</Listbox.Button>
          <Listbox.Options className="flex flex-col gap-4 top-10 z-50 absolute left-0 w-full bg-white rounded-md shadow-lg py-4 px-6 ring-1 ring-border focus:outline-none">
            {datas.map((person, index) => (
              <Listbox.Option
                className={`cursor-pointer text-xs hover:text-subMain`}
                key={person.id || index}
                value={person}
                disabled={person.unavailable}>
                {person.name}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Listbox>
      </div>
    </div>
  );
}
// switch

export function Switchi({ checked, onChange }) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={`${checked ? "bg-subMain" : "bg-border"}
        relative inline-flex p-[2px] w-12 cursor-pointer rounded-full transitions`}>
      <span
        aria-hidden="true"
        className={`${checked ? "translate-x-5" : "translate-x-0"}
          pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-lg  transitions`}
      />
    </Switch>
  );
}

// textarea

export function Textarea({
  label,
  name,
  register,
  placeholder,
  rows,
  value,
  onChange,
}) {
  return (
    <div className="text-sm w-full">
      <label className={"text-black text-sm"}>{label}</label>
      <textarea
        name={name}
        rows={rows}
        {...register}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`focus:border-subMain w-full bg-transparent text-sm mt-3 p-4 border border-border rounded-lg font-light 
         `}
      />
    </div>
  );
}

// date picker
export function DatePickerComp({
  label,
  startDate,
  onChange,
  minDate,
  maxDate,
  disabled = false,
}) {
  return (
    <div className="text-sm w-full flex flex-col">
      <label className="text-black text-sm ">{label}</label>{" "}
      {/* Add margin-bottom */}
      <DatePicker
        selected={startDate}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        dateFormat="dd/MM/yyyy"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-border font-light rounded-lg focus:border focus:border-subMain"
        disabled={disabled}
      />
    </div>
  );
}

// time picker

export function TimePickerComp({
  label,
  startDate,
  onChange,
  disabled = false,
}) {
  return (
    <div className="text-sm w-full">
      <label className={"text-black text-sm"}>{label}</label>
      <DatePicker
        selected={startDate}
        onChange={onChange}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={30}
        timeCaption="Time"
        dateFormat="h:mm aa"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-border font-light rounded-lg focus:border focus:border-subMain"
        disabled={disabled}
      />
    </div>
  );
}

// checkbox

export function Checkbox({ label, name, onChange, checked }) {
  return (
    <div className="text-sm w-full flex flex-row items-center">
      {/* design checkbox */}
      <label className="flex-colo cursor-pointer relative">
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          className="absolute opacity-0 w-0 h-0"
        />
        <span
          className={` border rounded-lg  w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${
            checked ? "border-subMain bg-subMain" : "border-gray-300 bg-white"
          }`}>
          <FaCheck
            className={`text-[10px] ${checked ? "block text-white" : "hidden"}`}
          />
        </span>
      </label>

      {label && <p className={"text-black text-xs ml-2"}>{label}</p>}
    </div>
  );
}

// from to date picker

export function FromToDate({ label, startDate, onChange, endDate, bg }) {
  return (
    <div className="text-sm w-full flex flex-col gap-2">
      {label && <label className={"text-black text-sm"}>{label}</label>}
      <DatePicker
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        onChange={onChange}
        className={`w-full ${
          bg ? bg : "bg-transparent"
        }  text-xs px-4 h-14 border border-border text-main font-normal rounded-lg focus:border focus:border-subMain`}
      />
    </div>
  );
}
